/**
 * /K33944/ Instead of trimming the string, I write a function for future use around this kind of timestamp strings
 * Formats a date string into MM/DD/YYYY format
 * @param {string} dateString - The input date string to format
 * @returns {string} The formatted date string in MM/DD/YYYY format
 */

/**
 * Converts a date string to a timestamp for sorting.
 * Handles MM/YYYY (inserts day 01) and returns Infinity for empty/null values
 * so they sort first in descending order.
 */
export function toTime(d: string): number {
  if (!d) return Infinity;
  const slashes = (d.match(/\//g) || []).length;
  if (slashes === 1) {
    const i = d.indexOf('/');
    d = `${d.slice(0, i)}/01${d.slice(i)}`;
  }
  return new Date(d).getTime() || Infinity;
}

export function formatDateToMMDDYYYY(dateString: string): string {
  // Replace hyphen with 'T' before time portion to ensure proper date parsing
  const date = new Date(dateString.replace(/-(?=\d{2}:\d{2}$)/, 'T'));
  // Format date components with padding and combine into MM/DD/YYYY string
  return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
}
